import { Router } from '@angular/router';
import { Component, OnInit, HostListener, EventEmitter, Output } from '@angular/core';
@Component({
  selector: 'app-service-footer',
  templateUrl: './service-footer.component.html',
  styleUrls: ['./service-footer.component.less']
})
export class ServiceFooterComponent implements OnInit {


  @Output() removeActiveInHeader = new EventEmitter();
  selectedMenu = false;
  year: string;


  constructor(private router: Router) { }
  ngOnInit() {
    this.year = (new Date()).getFullYear().toString();
  }
  canceltoggleEmp() {
    localStorage.setItem("tab_value", "0");
    this.router.navigate(['/service']);
  }
  canceltoggleEmp1() {
    localStorage.setItem("tab_value", "4");
    this.router.navigate(['/service']);
  }
}


